module.exports = __webpack_public_path__ + "img/dice-yxx3-2.25a44468.svg";